import Axios from 'axios'
import { headers } from '../../../../utilities/token'

export const POST_VISITOR = 'POST_VISITOR'
export const POST_VISITOR_FULFILLED = 'POST_VISITOR_FULFILLED'
export const POST_VISITOR_REJECTED = 'POST_VISITOR_REJECTED'

export const GET_VISITORS = 'GET_VISITORS'
export const GET_VISITORS_FULFILLED = 'GET_VISITORS_FULFILLED'
export const GET_VISITORS_REJECTED = 'GET_VISITORS_REJECTED'

export const GET_VISITOR = 'GET_VISITOR'
export const GET_VISITOR_FULFILLED = 'GET_VISITOR_FULFILLED'
export const GET_VISITOR_REJECTED = 'GET_VISITOR_REJECTED'

export const PUT_VISITOR = 'PUT_VISITOR'
export const PUT_VISITOR_FULFILLED = 'PUT_VISITOR_FULFILLED'
export const PUT_VISITOR_REJECTED = 'PUT_VISITOR_REJECTED'

export const DELETE_VISITOR = 'DELETE_VISITOR'
export const DELETE_VISITOR_FULFILLED = 'DELETE_VISITOR_FULFILLED'
export const DELETE_VISITOR_REJECTED = 'DELETE_VISITOR_REJECTED'

export const GET_SELECTED_KEYS_VISITOR = 'GET_SELECTED_KEYS_VISITOR'
export const GET_SELECTED_KEYS_VISITOR_FULFILLED = 'GET_SELECTED_KEYS_VISITOR_FULFILLED'
export const GET_SELECTED_KEYS_VISITOR_REJECTED = 'GET_SELECTED_KEYS_VISITOR_REJECTED'

const API_URL = process.env.REACT_APP_API_BASE_URL

export const loadVisitor = (status, pagination) => {
  return dispatch => {
    dispatch({
      type: GET_VISITORS,
      payload: {}
    })
    return Axios.get(`${API_URL}/visitors?page=${pagination.page}&limit=${pagination.limit}&searchTerm=${pagination.searchTerm}&status=${status}`, { headers: headers })
      .then(function (response) {
        dispatch({
          type: GET_VISITORS_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: GET_VISITORS_REJECTED,
          payload: error
        })
      })
  }
}

export const loadVisitorById = (id) => {
  return dispatch => {
    dispatch({
      type: GET_VISITOR,
      payload: {}
    })
    return Axios.get(`${API_URL}/visitor/${id}`, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: GET_VISITOR_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: GET_VISITOR_REJECTED,
          payload: error
        })
      })
  }
}


export const submitVisitor = (data) => {
  return dispatch => {
    dispatch({
      type: POST_VISITOR,
      payload: {}
    })
    return Axios.post(`${API_URL}/visitor`, { ...data }, { headers: headers })
      .then(function (response) {
        dispatch({
          type: POST_VISITOR_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: POST_VISITOR_REJECTED,
          payload: error
        })
      })
  }
}

export const updateVisitor = (data) => {
  return dispatch => {
    dispatch({
      type: PUT_VISITOR,
      payload: {}
    })
    return Axios.put(`${API_URL}/visitor/${data.id}`, { ...data }, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: PUT_VISITOR_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: PUT_VISITOR_REJECTED,
          payload: error
        })
      })
  }
}

export const deleteVisitor = (id) => {
  return dispatch => {
    dispatch({
      type: DELETE_VISITOR,
      payload: {}
    })
    return Axios.delete(`${API_URL}/visitor/${id}`, { headers: headers })
      .then(function (response) {
        dispatch({
          type: DELETE_VISITOR_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: DELETE_VISITOR_REJECTED,
          payload: error
        })
      })
  }
}

export const loadSelectedRowVisitor = (selectedKeys) => {
  return dispatch => {
    dispatch({
      type: GET_SELECTED_KEYS_VISITOR,
      payload: {}
    })
    return Axios.get(`${API_URL}/visitorIds?selectedIds=${selectedKeys.toString()}`, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: GET_SELECTED_KEYS_VISITOR_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: GET_SELECTED_KEYS_VISITOR_REJECTED,
          payload: error
        })
      })
  }
}





